import React from 'react';
import { Link } from 'react-router-dom';

const cards = [
  {
    id: 'studio',
    number: '[ 01 ]',
    label: 'PODCAST & VIDEO STUDIO | FREMONT, CA',
    title: 'STUDIO SESSIONS',
    image: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2Uvd2VicA==/34d2ea00f9857bd86bb74153c0d48f40.webp',
    alt: 'Studio Session set up at Bay Area Podcast Studio in Fremont CA',
    body: 'You walk in, sit down, and record. We dial in the cameras, set the lighting, and monitor your audio. When you wrap, you walk out with your raw 4K files immediately.',
    items: ['4K Multi-Cam & Studio Mics', 'Studio Engineer Included', 'Instant Raw File Handoff'],
    href: '/studio-sessions',
    cta: 'VIEW PRICING & SETS',
    buttonClass: 'bg-black text-white border-black hover:bg-neutral-800',
  },
  {
    id: 'services',
    number: '[ 02 ]',
    label: 'ON-LOCATION PRODUCTION',
    title: 'VIDEO SERVICES',
    image: 'https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/b06bf1d16dcfaf9881005f6ac7d87fd4.png',
    alt: 'On-location video production equipment and crew in the Bay Area',
    body: 'Full video production brought directly to your location. We bring 4K cinema cameras, lighting, and audio gear to your office or event anywhere in the Bay Area.',
    items: ['Executive Interviews & Brand Content', 'Pro Camera, Light & Sound Setup', 'Fast File Delivery'],
    href: '/video-services',
    cta: 'VIEW VIDEO SERVICES',
    imageClass: 'object-[center_40%]',
    buttonClass: 'bg-white text-black border-black hover:bg-black hover:text-white',
  },
];

export default function SplitCards() {
  return (
    <section
      aria-label="How we work — Studio Sessions and Video Services"
      className="w-full bg-white py-12 md:py-20 px-5 md:px-12"
    >
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-8 md:mb-12">
          <p className="text-black text-xs md:text-sm font-black uppercase tracking-[0.25em] mb-3 md:mb-4">
            [ HOW WE WORK ]
          </p>
          <h2 className="text-black text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black tracking-tight max-w-4xl leading-tight">
            Our Studio or Your Location. Same High Standard.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-white border-2 border-black flex flex-col overflow-hidden group hover:shadow-2xl transition-all duration-300"
            >
              <div className="aspect-video w-full overflow-hidden border-b-2 border-black relative">
                <img
                  src={card.image}
                  alt={card.alt}
                  className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out ${card.imageClass || ''}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="p-6 md:p-10 flex flex-col flex-1">
                <p className="text-black text-xs font-mono font-black tracking-widest mb-2">
                  {card.number}
                </p>
                <p className="text-black text-xs font-black uppercase tracking-widest mb-3">
                  {card.label}
                </p>
                <h3 className="text-black text-xl md:text-3xl font-black uppercase tracking-tight mb-3">
                  {card.title}
                </h3>
                <p className="text-black text-sm md:text-base font-medium leading-relaxed mb-5">
                  {card.body}
                </p>
                <ul className="text-black font-bold space-y-2 mb-7 text-sm md:text-base">
                  {card.items.map((item) => (
                    <li key={item} className="flex items-start">
                      <span className="mr-3 mt-2 w-1.5 h-1.5 bg-black shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link
                  to={card.href}
                  className={`mt-auto block text-xs md:text-sm font-bold tracking-[0.15em] uppercase py-4 px-8 w-full text-center border-2 transition-colors ${card.buttonClass}`}
                >
                  {card.cta}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}